"use client"

import Accordion from "./accordion"

const SECTIONS = [
  {
    label: "Envío",
    body: "Preparamos cada pedido en 24 h laborables y lo enviamos con la agencia de transporte más conveniente. Entrega en 2-4 días laborables, o 24-48 h con envío express. Recibirás el número de seguimiento por email.",
  },
  {
    label: "Devoluciones",
    body: "Tienes 30 días para devolver cualquier pieza sin usar. Solicita la devolución desde tu cuenta o desde Consultar un pedido y generaremos la etiqueta de recogida.",
  },
  {
    label: "Garantía",
    body: "Todas las piezas tienen 3 años de garantía legal frente a defectos de fabricación.",
  },
]

const ProductTabs = () => (
  <Accordion type="multiple">
    {SECTIONS.map((s) => (
      <Accordion.Item key={s.label} title={s.label} headingSize="medium" value={s.label}>
        <p className="text-sm text-zl-steel pt-2 pb-3 max-w-md">{s.body}</p>
      </Accordion.Item>
    ))}
  </Accordion>
)

export default ProductTabs
